import React from "react";
import { BaseBox, BaseButton, BaseTypography } from "../exports";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

export default function BaseSidebar({ items = [], open = false, onToggle }) {
  const headerHeight = 64; // header height
  const footerHeight = 40; // approximate footer height
  const overlap = 15; // extend under header a little
  const topOffset = headerHeight - overlap;

  return (
    <BaseBox
      sx={{
        position: "fixed",
        top: `${topOffset}px`,
        left: 0,
        height: `calc(100vh - ${topOffset + footerHeight}px)`, // reduce height to leave space for footer
        width: open ? 220 : 50,
        transition: "width 0.28s, left 0.28s",
        backgroundColor: "background.paper",
        borderRight: 1,
        borderColor: "divider",
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        zIndex: 990,
        overflow: "hidden",
      }}
    >
      {/* Toggle Button */}
      <BaseBox sx={{ p: 1, display: "flex", justifyContent: open ? "flex-end" : "center" }}>
        <BaseButton onClick={onToggle} size="small" sx={{ minWidth: "auto", p: 0.5 }}>
          {open ? <CloseIcon fontSize="small" /> : <MenuIcon fontSize="small" />}
        </BaseButton>
      </BaseBox>

      {/* Menu Items */}
      <BaseBox sx={{ flex: 1, mt: 1, display: "flex", flexDirection: "column", alignItems: "stretch" }}>
        {items.map((item, idx) => (
          <BaseButton
            key={idx}
            onClick={item.onClick}
            sx={{
              display: "flex",
              justifyContent: open ? "flex-start" : "center",
              alignItems: "center",
              width: "100%",
              mb: 1,
              px: 2,
              minHeight: 40,
              textTransform: "none",
            }}
          >
            {item.icon && (
              <span style={{ marginRight: open ? 8 : 0, display: "flex", alignItems: "center" }}>
                {item.icon}
              </span>
            )}
            {open && <BaseTypography sx={{ fontSize: "0.95rem" }}>{item.label}</BaseTypography>}
          </BaseButton>
        ))}
      </BaseBox>
    </BaseBox>
  );
}
